import React from 'react';
import { toAbsoluteUrl } from "../../../_metronic/_helpers/AssetsHelpers";
import { Box } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { timeline } from '../style';
import loadIcon from "../../../assets/images/icons/loadCount.svg"
import hook from "../../../assets/images/icons/hook.svg";
import unhook from "../../../assets/images/icons/unhook.svg";
import pickup from "../../../assets/images/icons/pickUp.svg";
import dropoff from "../../../assets/images/icons/dropOff.svg";
import delivery from "../../../assets/images/icons/delivery.svg";
import { useTranslation } from 'react-i18next';

interface MapLegendProps {
    showIconLeft: boolean;
    openTrackingPosition: boolean;
}

const activityIcons: Record<string, string> = {
    DELIVERY: delivery,
    LOAD: loadIcon,
    HOOK: hook,
    UNHOOK: unhook,
    PICKUP: pickup,
    DROPOFF: dropoff,
};


const MapLegend: React.FC<MapLegendProps> = ({ showIconLeft, openTrackingPosition }) => {
    const leftPos = showIconLeft ? (openTrackingPosition ? "420px" : "0px") : "";
    const { t } = useTranslation();

    return (
        <div
            className="
                absolute top-12 bg-white rounded-[3px] p-4 min-w-max
                grid grid-cols-[40px_auto] items-center gap-x-4 gap-y-2
            "
            style={{ left: leftPos }}
        >
            <img className="w-[25px] mx-auto" src={toAbsoluteUrl("/media/svg/map/actual-position.svg")} alt="" />
            <p className="m-0">{t("screens.trips.mapLegend.actualPosition")}</p>

            <div className="w-[20px] h-[20px] mx-auto rounded-[10px] border-2 border-[#CF0A2C] bg-white" />
            <p className="m-0">GPS Telematics</p>


            <Box
                style={{
                    borderRadius: "50%",
                    backgroundColor: "#CF0A2C",
                    width: 25,
                    height: 25,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "auto",
                    marginRight: "auto"
                }} >
                <img className="w-[20px] mx-auto" src={activityIcons.DELIVERY} alt="Delivery icon" />

            </Box>
            <p className="m-0 ">Delivery</p>

            <Box
                style={{
                    borderRadius: "50%",
                    backgroundColor: "#CF0A2C",
                    width: 25,
                    height: 25,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "auto",
                    marginRight: "auto"
                }} >
                <img className="w-[20px] mx-auto" src={activityIcons.LOAD} alt="Load icon" />


            </Box>
            <p className="m-0 ">Load</p>
            
            <Box
                style={{
                    borderRadius: "50%",
                    backgroundColor: "#CF0A2C",
                    width: 25,
                    height: 25,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "auto",
                    marginRight: "auto"
                }} >
                <img className="w-[20px] mx-auto" src={activityIcons.PICKUP} alt="Pickup icon" />


            </Box>
            <p className="m-0 ">Pickup</p>
            <Box
                style={{
                    borderRadius: "50%",
                    backgroundColor: "#CF0A2C",
                    width: 25,
                    height: 25,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "auto",
                    marginRight: "auto"
                }} >
                <img className="w-[20px] mx-auto" src={activityIcons.DROPOFF} alt="Dropoff icon" />


            </Box>
            <p className="m-0 ">Dropoff</p>
            <Box
                style={{
                    borderRadius: "50%",
                    backgroundColor: "#CF0A2C",
                    width: 25,
                    height: 25,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "auto",
                    marginRight: "auto"
                }} >
                <img className="w-[20px] mx-auto" src={activityIcons.HOOK} alt="Hook icon" />


            </Box>
            <p className="m-0 ">Hook</p>
           

            <Box
                style={{
                    borderRadius: "50%",
                    backgroundColor: "#CF0A2C",
                    width: 25,
                    height: 25,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "auto",
                    marginRight: "auto"
                }} >
                <img className="w-[20px] mx-auto" src={activityIcons.UNHOOK} alt="Unhook icon" />


            </Box>
            <p className="m-0 ">Unhook</p>

         

        </div>
    );
};

export default MapLegend;
